"use client";

import { Moon, Sun } from "lucide-react";

export const THEME_STORAGE_KEY = "prosa-theme";

/**
 * Light/dark toggle. The current theme lives ONLY on <html class="dark"> —
 * set before hydration by the inline script in app/layout.tsx — so the icons
 * swap with CSS (`dark:` variants) and the component needs no state, which is
 * also what makes it hydration-safe: the server markup is identical for both
 * themes.
 *
 * A click stores an explicit choice; until then the theme follows
 * prefers-color-scheme.
 */
export function ThemeToggle() {
  function toggle() {
    const isDark = document.documentElement.classList.toggle("dark");
    try {
      window.localStorage.setItem(THEME_STORAGE_KEY, isDark ? "dark" : "light");
    } catch {
      // Storage unavailable (private mode): the theme still switches for
      // this page view, it just won't persist.
    }
  }

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label="Switch between light and dark theme"
      title="Switch theme"
      className="flex h-9 w-9 items-center justify-center rounded-[8px] text-muted transition-colors hover:bg-ink/[0.05] hover:text-ink"
    >
      <Sun className="hidden h-[18px] w-[18px] dark:block" />
      <Moon className="h-[18px] w-[18px] dark:hidden" />
    </button>
  );
}
